import React from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  CustomInput,
  Input,
} from "../../../Components/CustomComponents";
import Fieldset from "../../../Components/FieldSet";
import { Form, InputGroup } from "react-bootstrap";

const EliteAgentForm = () => {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      month_fee: "",
      anual_fee: "",
      features: "",
    },
  });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <h6>Monthly Price ($)</h6>
      <Controller
        name="month_fee"
        control={control}
        rules={{ required: "Consumer Platform Fee is required" }}
        render={({ field }) => (
          <InputGroup className="my-2">
            <CustomInput
              {...field}
              placeholder="Enter Consumer Platform Fee in percentage"
              type="number"
            />
          </InputGroup>
        )}
      />

      <h6>Annual Price ($)</h6>
      <Controller
        name="anual_fee"
        control={control}
        rules={{ required: "Agent Platform Fee is required" }}
        render={({ field }) => (
          <InputGroup className="my-2">
            <CustomInput
              {...field}
              placeholder="Enter Agent Platform Fee in percentage"
              type="number"
            />
          </InputGroup>
        )}
      />

      <h6>Feature</h6>
      <Controller
        name="features"
        control={control}
        rules={{ required: "Brokerage Access Fee is required" }}
        render={({ field }) => (
          <InputGroup className="my-2">
            <Input
              {...field}
              placeholder="Enter Brokerage Access Fee in $"
              type="textarea"
              as="textarea"
              rows={3}
            />
          </InputGroup>
        )}
      />

      <Button
        text={"Update"}
        classes={`fs-6 mb-2 mt-auto mt-3 mb-2`}
        type="submit"
      />
    </Form>
  );
};

export default EliteAgentForm;
